import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "notice-container"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "list-container"
};
const _hoisted_4 = {
  class: "left-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["title"];
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  class: "item-bottom"
};
const _hoisted_9 = {
  class: "item-time"
};
const _hoisted_10 = {
  class: "time-day"
};
const _hoisted_11 = {
  class: "time-year"
};
const _hoisted_12 = {
  class: "left-list"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["title"];
const _hoisted_15 = ["title"];
const _hoisted_16 = {
  class: "item-bottom"
};
const _hoisted_17 = {
  class: "item-time"
};
const _hoisted_18 = {
  class: "time-day"
};
const _hoisted_19 = {
  class: "time-year"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("img", {
    class: "title",
    src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/c465e033a1bd456291f20b7c6c83604e.png"
  }, null, -1)), _createElementVNode("div", {
    class: "more",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleMore && $options.handleMore(...args))
  }, _cache[1] || (_cache[1] = [_createElementVNode("span", {
    class: "text"
  }, "查看更多", -1), _createElementVNode("span", {
    class: "icon"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.leftList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["big-item", {
        'large-item': $data.leftList.length < 3 && $data.rightList == 0
      }]),
      onClick: $event => $options.handleDetail(item)
    }, [_createElementVNode("div", {
      class: "item-title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_6), _createElementVNode("div", {
      class: "item-sub-title",
      title: item.context
    }, _toDisplayString(item.context), 9, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.publish_time.slice(8, 10)), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.publish_time.slice(0, 7)), 1)]), _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "item-btn"
    }, null, -1))])], 10, _hoisted_5);
  }), 256))]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.rightList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "big-item",
      onClick: $event => $options.handleDetail(item)
    }, [_createElementVNode("div", {
      class: "item-title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_14), _createElementVNode("div", {
      class: "item-sub-title",
      title: item.context
    }, _toDisplayString(item.context), 9, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.publish_time.slice(8, 10)), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(item.publish_time.slice(0, 7)), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "item-btn"
    }, null, -1))])], 8, _hoisted_13);
  }), 256))])])]);
}